import { useEffect, useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { Button, Tooltip } from '@chakra-ui/react';

function ScrollToTopButton() {
  const [showScroll, setShowScroll] = useState(false);
  const scrollContainerRef = useRef<HTMLElement | null>(null);

  const scrollTop = (): void => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const container = document.getElementById('scrollable-wrapper');
    if (!container) return;

    scrollContainerRef.current = container;

    const checkScrollTop = () => {
      setShowScroll(container.scrollTop > 300);
    };

    container.addEventListener('scroll', checkScrollTop);
    return () => container.removeEventListener('scroll', checkScrollTop);
  }, []);

  if (!showScroll) return null;

  return (
    <Tooltip
      label="Scroll to top"
      aria-label="Scroll to top"
      hasArrow
      borderRadius={4}
      placement="top"
    >
      <Button
        onClick={scrollTop}
        position="fixed"
        bottom="75px"
        right="40px"
        zIndex="1000"
        size="sm"
        variant="primary"
        borderRadius="full"
        p={0}
        w="40px"
        h="40px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon icon={faArrowUp} size="lg" />
      </Button>
    </Tooltip>
  );
}

export default ScrollToTopButton;
